import { Query } from '../../_base/actionBus/Query';
import { Document } from '../../models/documents/Document';
import { Nullable } from '../../_base/lang/Nullable';

export class GetPublicDocuments extends Query<Document[]> {
    constructor(public associationId: string, public parentId: Nullable<number> = null) {
        super();
    }
}
